import React, { useState, useEffect, useContext, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import BtnAddToCareGroup from '../CareLabel/BtnAddToCareGroup';
import { CareUserContext } from './provider/careUserContext';
import * as action from './store/UserInstruction.action';
import './CareUserInstruction.css';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function UserLibraryFilter({ selectedLibrary, showButtons, fromCareAddEditGroup, hideShowDragDrop, fromGroup }) {
  const expandSearchRefBin = useRef(null);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const { _id, groupId } = useParams();
  const dispatch = useDispatch();
  const { UserInstructionDetails } = useSelector((state) => state);
  const { careUserGroupList } = UserInstructionDetails;
  const history = useHistory();
  const [downloadSelectLoading, setDownloadSelectLoading] = useState(false);
  const { state, setState, rows, handleSearch, CareAddEditAccess, CareDeleteAccess, handleDeleteMultiple, getGroupTabs, handleRefresh } =
    useContext(CareUserContext);
  const { t } = useTranslation('common');
  const [careGroupList, setCareGroupList] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const fromCareGroup = window?.location?.pathname?.includes('care-user-group-instruction');

  const handleUserInstructionLibrary = () => {
    if (showButtons) {
      const tabData = [];
      const lastIndex = rows?.length > 0 ? rows.length - 1 : 0;
      const lastRowIndex = rows?.length > 0 ? rows[lastIndex]?.[0]?.rowIndex : 0;

      if (state?.columns?.length > 0) {
        state?.columns?.forEach((column) => {
          tabData?.push({
            tabId: _id,
            rowIndex: rows?.length > 0 ? lastRowIndex + 1 : 0,
            columnId: column?._id,
            value: null,
          });
        });
      }
      setState((prevState) => ({
        ...prevState,
        tabData: [...prevState.tabData, tabData],
        addNewRow: true,
      }));
    } else if (fromCareGroup) {
      history.push('/libraries/care-user-group-instruction/add');
    } else {
      setState((prevState) => ({
        ...prevState,
        showTabModal: true,
      }));
    }
  };

  const isValid = () => {
    let error = false;
    if (
      !state?.careGroupDetails?.name ||
      !state?.careGroupDetails?.productType?.length ||
      !state?.careGroupDetails?.brandIds?.length ||
      !state?.careGroupDetails?.catOneIds?.length ||
      !state?.careGroupDetails?.catTwoIds?.length
    ) {
      error = true;
    }
    if (error) {
      setState((prevState) => ({
        ...prevState,
        careGroupDetails: {
          ...prevState?.careGroupDetails,
          error,
        },
      }));
      return false;
    }
    return true;
  };
  const handleGroupSave = async () => {
    if (isSaving) return;
    if (isValid()) {
      setIsSaving(true);
      const payload = {
        name: state?.careGroupDetails?.name,
        productType: state?.careGroupDetails?.productType?.length
          ? state?.careGroupDetails?.productType?.map((item) => ({
              label: item?.label,
              value: item?.value,
            }))
          : [],
        brandIds: state?.careGroupDetails?.brandIds?.length
          ? state?.careGroupDetails?.brandIds?.map((item) => ({
              label: item?.label,
              value: item?.value,
            }))
          : [],
        subBrandIds: state?.careGroupDetails?.subBrandIds?.length
          ? state?.careGroupDetails?.subBrandIds?.map((item) => ({
              label: item?.label,
              value: item?.value,
            }))
          : [],
        catOneIds: state?.careGroupDetails?.catOneIds?.length
          ? state?.careGroupDetails?.catOneIds?.map((item) => ({
              label: item?.label,
              value: item?.value,
            }))
          : [],
        catTwoIds: state?.careGroupDetails?.catTwoIds?.length
          ? state?.careGroupDetails?.catTwoIds?.map((item) => ({
              label: item?.label,
              value: item?.value,
            }))
          : [],
        catThreeIds: state?.careGroupDetails?.catThreeIds?.length
          ? state?.careGroupDetails?.catThreeIds?.map((item) => ({
              label: item?.label,
              value: item?.value,
            }))
          : [],
        catFourIds: state?.careGroupDetails?.catFourIds?.length
          ? state?.careGroupDetails?.catFourIds?.map((item) => ({
              label: item?.label,
              value: item?.value,
            }))
          : [],
        additonalInformation: state?.careGroupDetails?.additonalInformation,
        isRequired: state?.careGroupDetails?.isRequired,
        loggedInUserId: state?.userInfo?.userId,
        tabs: state?.careGroupDetails?.tabs.filter((item) => !item.forDocument),
        _id: groupId,
      };

      try {
        const res = await dispatch(action.saveCareUserGroup(payload, t));
        dispatch(action.checkUniqueProductType(state?.careGroupDetails?.isRequired || false));
        if (res?.code === 200 && !groupId) {
          history.push(`/libraries/care-user-group-instruction/edit/${res?.data?._id}`);
          getGroupTabs();
        }
      } catch (error) {
        console.error('Error during saving group:', error);
      } finally {
        setIsSaving(false);
      }
    }
  };
  function openColumnConfig() {
    setState((prevState) => ({
      ...prevState,
      showColumnConfig: true,
    }));
  }

  const handleDownload = async (type) => {
    if (type === 'All') {
      setDownloadLoading(true);
      const data = { _id, tabName: state?.tabName };
      await dispatch(action.downloadCareLibrary(data));
      setDownloadLoading(false);
    } else if (type === 'Sample') {
      const data = {
        type: 'sample',
        tabName: state?.tabName,
        _id,
      };
      await dispatch(action.downloadCareLibrary(data));
    } else if (type === 'selected') {
      setDownloadSelectLoading(true);
      const data = {
        careIds: state?.selectedIdArray,
        tabName: state?.tabName,
        _id,
      };
      await dispatch(action.downloadCareLibrary(data));
      setDownloadSelectLoading(false);
    }
  };

  const uploadXlsx = () => {
    setState((prevState) => ({
      ...prevState,
      showUploadModal: true,
    }));
  };

  const goToBack = () => {
    setState((prevState) => ({
      ...prevState,
      searchText: '',
      searchLoaded: false,
      fromTab: false,
      editingRowId: '',
      addNewRow: false,
      tabName: '',
    }));
    if (fromCareAddEditGroup) {
      setState((prevState) => ({
        ...prevState,
        careGroupDetails: {
          name: '',
          productType: [],
          error: false,
          additionalInformation: '',
          tabs: [],
        },
        updatedTabDetails: [],
        accordianArray: [],
      }));
      history.push('/libraries/care-user-group-instruction');
    } else {
      history.push('/libraries/care-user-instruction');
    }
  };

  const handleOpenProductGroup = () => {
    history.push('/libraries/care-user-group-instruction/add');
  };

  useEffect(() => {
    if (window.location.href.includes('care-user-instruction')) {
      dispatch(action.fetchUserInstructionCareGroupAction());
    }
  }, [dispatch]);

  useEffect(() => {
    if (careUserGroupList?.length > 0) {
      setCareGroupList(careUserGroupList);
    }
  }, [careUserGroupList]);

  const handleIconBinClick = () => {
    // Add a class to the input on icon click
    expandSearchRefBin.current.classList.toggle('active-input');
  };

  const onBtnClick = (selectedId) => {
    if (state?.selectedIdArray?.length > 0) {
      const tabDetails = rows.flatMap((ele) => ele).filter((ele) => state.selectedIdArray.includes(ele?.rowId));
      setState((prevState) => ({
        ...prevState,
        updatedTabDetails: tabDetails,
      }));
      if (selectedId?._id) {
        history.push(`/libraries/care-user-group-instruction/edit/${selectedId._id}`, tabDetails);
      }
    } else {
      toasterMsg(t('CARE_LABELS.LIBRARY_FILTER.CARE_LABEL_GROUP'), 'danger');
    }
  };

  return (
    <div className="search-filter action-icons-container care-library-filter">
      {!fromCareAddEditGroup && (
        <div ref={expandSearchRefBin} className="common-expand-search">
          <button type="button" onClick={handleIconBinClick} className="btn btn-toggle">
            <span className="sr-only ">{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.SEARCH USER_INSTRUCTION')}</span>
            <span className="icon-Magnifying-Glass-Solid" />
          </button>
          <input
            type="text"
            className="form-control"
            onChange={(e) => handleSearch(e, showButtons, fromGroup)}
            value={state?.searchText}
            autoComplete="off"
            placeholder={
              state?.tabName
                ? `${t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.SEARCH')} ${state?.tabName} ${t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.DETAILS')}`
                : t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.SEARCH')
            }
          />
        </div>
      )}
      <div className="floting-actions">
        {!fromCareAddEditGroup && CareAddEditAccess && (
          <CustomTooltip placement="top" tooltipText={t('DAM_HISTORY.LISTING_VIEW.ADD')}>
            <button type="button" aria-label="add" onClick={handleUserInstructionLibrary} className="btn" disabled={state?.editingRowId || state?.addNewRow}>
              <i className="icon-Add" />
            </button>
          </CustomTooltip>
        )}
        {fromCareAddEditGroup && (
          <CustomTooltip placement="top" tooltipText={t('DAM_HISTORY.LISTING_VIEW.SAVE')}>
            <button
              type="button"
              aria-label="save"
              disabled={state?.careGroupDetails?.isSaveDisable || isSaving}
              onClick={handleGroupSave}
              className="btn"
            >
              <i className="icon-Save-1 f-24 mr-1" />
            </button>
          </CustomTooltip>
        )}
        {fromCareAddEditGroup && (
          <CustomTooltip placement="top" tooltipText={t('COLOUR_SUPPORTING_DOCUMENT.REARRANGE')}>
            <button aria-label="rearrange" type="button" className="btn" onClick={hideShowDragDrop}>
              <i className="icon-Rearrange  f-24" />
            </button>
          </CustomTooltip>
        )}

        {showButtons && CareAddEditAccess && (
          <CustomTooltip placement="top" tooltipText={t('COLOUR_SUPPORTING_DOCUMENT.SETTING')}>
            <button type="button" aria-label="Setting" onClick={openColumnConfig} className="btn">
              <i className="icon-Settings" />
            </button>
          </CustomTooltip>
        )}
        {fromCareAddEditGroup && groupId && (
          <CustomTooltip placement="top" tooltipText={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.REFRESH')}>
            <button aria-label="refresh" type="button" className="btn" onClick={() => handleRefresh(groupId)}>
              <i className="icon-Replace" />
            </button>
          </CustomTooltip>
        )}
        {showButtons && CareAddEditAccess && (
          <CustomTooltip placement="top" tooltipText={t('CARE_LABEL.UPLOAD_EXCEL_DOCUMENT')}>
            <button type="button" className="btn" aria-label={t('CARE_LABEL.UPLOAD_EXCEL_DOCUMENT')} onClick={uploadXlsx}>
              <i className="icon-Upload-1 save-icon" />
            </button>
          </CustomTooltip>
        )}
        {showButtons && (
          <OverlayTrigger
            placement="top"
            trigger="click"
            rootClose
            overlay={
              <Popover className="custom-popover file-download-popover">
                <Popover.Content>
                  <ul>
                    <li>
                      <button className="p-0 btn" type="button" onClick={() => handleDownload('Sample')}>
                        {t('COLOUR_LIBRARY.DOWNLOAD_SAMPLE_FILE')}
                      </button>
                    </li>
                    <li>
                      <button className="p-0 btn" type="button" disabled={isEmpty(state?.selectedIdArray)} onClick={() => handleDownload('selected')}>
                        {downloadSelectLoading ? 'Downloading...' : `${t('COLOUR_LIBRARY.DOWNLOAD_SELECTED_DATA')}`}
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        disabled={!state?.tabData?.length}
                        onClick={() => handleDownload('All')}
                        className={downloadLoading ? ' disabled-btn p-0 btn' : ' p-0 btn'}
                      >
                        {downloadLoading ? 'Downloading...' : `${t('COLOUR_LIBRARY.DOWNLOAD_ALL_DATA')}`}
                      </button>
                    </li>
                  </ul>
                </Popover.Content>
              </Popover>
            }
          >
            <button className="btn" type="button" aria-label={t('CARE_LABELS.LIBRARY_FILTER.DOWNLOAD')}>
              <CustomTooltip placement="top" tooltipText={t('CARE_LABELS.LIBRARY_FILTER.DOWNLOAD')}>
                <i className="icon-Download1" />
              </CustomTooltip>
            </button>
          </OverlayTrigger>
        )}
        {!fromCareAddEditGroup && CareDeleteAccess && (
          <CustomTooltip placement="top" tooltipText={t('COLOR_WAY_CARD.DELETE')}>
            <button
              type="button"
              aria-label={t('COMMON_LABEL.DELETE')}
              onClick={() => handleDeleteMultiple(state?.deleteId)}
              className="btn"
              disabled={!selectedLibrary?.length}
            >
              <i className="icon-Delete" />
            </button>
          </CustomTooltip>
        )}
        {showButtons && CareAddEditAccess && (
          <BtnAddToCareGroup onBtnClick={onBtnClick} value={state?.selectedIdArray} handleOpenProductGroup={handleOpenProductGroup} options={careGroupList} />
        )}
      </div>
      {(fromCareAddEditGroup || showButtons) && (
        <CustomTooltip tooltipText={t('COLOUR_SUPPORTING_DOCUMENT.CLOSE')}>
          <button className="btn p-0 ml-8 d-inline-flex " aria-label="button" onClick={goToBack} type="button">
            <i className="icon-close cursor-pointer f-18" />
          </button>
        </CustomTooltip>
      )}
      {!fromCareAddEditGroup &&
        !showButtons &&
        (window.location.href.includes('care-user-instruction') ? (
          <button
            type="button"
            className={`cursor-pointer text-dark text-decoration-none ${
              window.location.href.includes('care-user-group-instruction') ? 'btn-active f-14 group-btn btn  mb-0' : 'btn group-btn f-14   mb-0'
            }`}
            onClick={() => history.push('/libraries/care-user-group-instruction')}
          >
            {t('COLOUR_LIBRARYS.COLOUR_LIBRARY.GROUPS')}
          </button>
        ) : (
          <button
            type="button"
            className={`cursor-pointer text-dark text-decoration-none ${
              window.location.href.includes('care-user-instruction') ? 'btn-active f-14 group-btn btn mb-0' : 'group-btn f-14 btn mb-0'
            }`}
            onClick={() => history.push('/libraries/care-user-instruction')}
          >
            {t('COLOUR_LIBRARYS.COLOUR_LIBRARY.LIBRARY')}
          </button>
        ))}
      {/* move the bellow button at the bottom */}
    </div>
  );
}

export default UserLibraryFilter;
